import {
  Button,
  Grid,
  IconButton,
  styled,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import MWCaption from "../../components/MWCaption";

import PersonIcon from "@mui/icons-material/Person";
import {Box} from "@mui/system";

import {EQCompany} from "../../models/serverModels/EQCompany";
import MWInputFile from "../../components/MWInputFile";
import {useConvertBase64} from "../../hooks/useConvertBase64";
import DeleteIcon from "@mui/icons-material/Delete";

const CategoryFormContainer = styled(Grid)(({theme}) => ({
  justifyContent: "center",
  alignItems: "center",
  marginTop: "16px",

  backgroundColor: "#fff",
  "& p": {
    marginTop: "8px",
  },
}));
const CategoryFormContent = styled(Grid)(({theme}) => ({
  display: "flex",
  flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "32px 0",

  padding: "24px",
  border: `1px solid ${theme.palette.background.paper}`,
  borderRadius: "16px",
  boxShadow:
    "rgb(0 0 0 / 10%) 0rem 0.25rem 0.375rem -0.0625rem, rgb(0 0 0 / 6%) 0rem 0.125rem 0.25rem -0.0625rem",

  "& label": {
    fontWeight: 600,
    paddingRight: "8px",
  },
}));

const DocumentList = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& label": {
    flexBasis: "30%",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));
const CompanyForm = () => {
  const {convertChangeHandler, image} = useConvertBase64();

  const isMobile = useMediaQuery("(max-width: 900px)");

  const methods = useFormContext<EQCompany>();
  const {
    setValue,
    control,
    watch,
    formState: {errors},
  } = methods;

  return (
    <React.Fragment>
      <MWCaption title="설비업체 관리" icon={<PersonIcon />} />
      <CategoryFormContainer container>
        <CategoryFormContent
          item
          xs={12}
          sm={12}
          md={6}
          xl={4}
          sx={{padding: {xs: "16px 4px", sm: "16px 8px", md: "24px"}}}
        >
          <Controller
            name="name"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="name">회사명 : </label>
                <TextField
                  {...field}
                  id="name"
                  size="small"
                  placeholder="회사명"
                  margin="dense"
                  helperText={error?.message}
                  autoFocus
                  sx={{width: "100%"}}
                />
              </DocumentList>
            )}
          />

          <Controller
            name="companyCode"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="companyCode">기업코드 : </label>
                <TextField
                  {...field}
                  id="companyCode"
                  size="small"
                  placeholder="기업코드"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%", color: "#000"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="phone"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="phone">연락처 : </label>
                <TextField
                  {...field}
                  id="phone"
                  size="small"
                  placeholder="연락처"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%", color: "#000"}}
                />
              </DocumentList>
            )}
          />
          <Controller
            name="address"
            control={control}
            render={({field, fieldState: {error}}) => (
              <DocumentList>
                <label htmlFor="address">주소 : </label>
                <TextField
                  {...field}
                  id="address"
                  size="small"
                  placeholder="주소"
                  margin="dense"
                  helperText={error?.message}
                  sx={{width: "100%", color: "#000"}}
                />
              </DocumentList>
            )}
          />
          {isMobile ? (
            <Box sx={{padding: "8px 4px", width: "100%"}}>
              <MWInputFile file="base64" fileName="companyLogo" buttonLabel="회사로고" />
            </Box>
          ) : (
            <Controller
              name="base64"
              control={control}
              render={({field: {onChange, name, value}, fieldState: {error}}) => (
                <>
                  <Grid
                    container
                    sx={{
                      marginTop: "12px",
                      flexWrap: "nowrap",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{display: "flex", alignItems: "center"}}>
                      <label htmlFor="base64" style={{whiteSpace: "nowrap"}}>
                        회사로고 :{" "}
                      </label>
                      <Button
                        variant="outlined"
                        component="label"
                        size="small"
                        sx={{height: "30px", whiteSpace: "nowrap"}}
                      >
                        파일 선택
                        <TextField
                          sx={{display: "none"}}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                            convertChangeHandler(event, setValue, name, "companyLogo")
                          }
                          type="file"
                          id="base64"
                          size="small"
                          hidden
                        />
                      </Button>
                      <Typography align="left" sx={{marginLeft: "8px"}}>
                        {watch("companyLogo")}
                      </Typography>
                    </Box>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => {
                        setValue("base64", "");
                        setValue("companyLogo", "");
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    {errors.base64 && <Typography>{errors.base64.message}</Typography>}
                  </Grid>
                  {errors && (
                    <Typography sx={{fontSize: "12px", color: "red"}}>{error?.message}</Typography>
                  )}
                </>
              )}
            />
          )}
        </CategoryFormContent>
      </CategoryFormContainer>
    </React.Fragment>
  );
};

export default CompanyForm;
